import styled from 'styled-components'
import { Typography } from 'common/typography'
import { useInitalLessons } from 'querys/lesson'
import { useCourse } from 'querys/course'
import Divider from 'common/divider'
import FreeVideoComponent from 'common/video/free-video-component'

const FreeClassStyled = styled.div`
  h3 {
    margin-bottom: 16px;
  }
`

function FreeClass() {
  const { data, isLoading, isError } = useInitalLessons()
  const { data: { featured_lesson } } = useCourse()

  if (isLoading || isError || !data) return null

  const featured = featured_lesson ? {
    title: null,
    provider_id: featured_lesson.provider_id,
    thumb: featured_lesson.thumbnails[1].link,
  } : null
  const lessonList = data.flatMap(({ lessons }) => lessons)
  const publicLesson = lessonList.filter(({ is_public, video }) => is_public && video?.provider_id)
  const firstFreeLesson = publicLesson.map(({ video: { provider_id, thumb_url }, title }) => ({ title, provider_id, thumb: thumb_url?.link }))[0]
  const freeLesson = featured || firstFreeLesson

  if (freeLesson) {
    return (
      <>
        <Divider marginVertical={48} stroke={1} color="var(--neutral80)" />
        <FreeClassStyled role="region" aria-labelledby="free-title">
          <Typography as="h3" color="var(--baseNeutral)" small="headline6" large="headline5" id="free-title">
            Toma una clase de prueba
          </Typography>
          <FreeVideoComponent {...freeLesson} />
        </FreeClassStyled>
      </>
    )
  }

  return null
}

export default FreeClass
